import { useTranslation } from "next-i18next"
import { sanitizeText } from "@/utils/helper"

const useRegisterOnlineProducti18n = ({ componentProps }) => {
  const { t } = useTranslation()
  const i18n = {
    backToMyProducts: t("kf.registeronlineproduct.label.backToMyProducts"),
    registerProducts: t("kf.registeronlineproduct.label.registerProducts"),
    selectProducts:
      componentProps?.copyText ??
      t("kf.registeronlineproduct.label.selectProducts"),
    review: t("kf.registeronlineproduct.label.review"),
    register: t("kf.registeronlineproduct.label.register"),
    next: t("kf.registeronlineproduct.label.next"),
    purchased: t("kf.registeronlineproduct.label.purchased"),
    color: t("kf.registeronlineproduct.label.color"),
    finish: t("kf.registeronlineproduct.label.finish"),
    selectAll: t("kf.registeronlineproduct.label.selectAll"),
    unSelectAll: t("kf.registeronlineproduct.label.unSelectAll"),
    reviewProducts: t("kf.registeronlineproduct.label.reviewProducts"),
    productRegSummary: t("kf.registeronlineproduct.label.productRegSummary"),
    productReg: t("kf.registeronlineproduct.label.productReg"),
    registerInfo: t("kf.registeronlineproduct.label.registerInfo"),
    dateOfInstallation: t("kf.registeronlineproduct.label.dateOfInstallation"),
    registeredAcc: componentProps?.registeredAcc
      ? sanitizeText(componentProps?.registeredAcc)
      : t("kf.registeronlineproduct.label.registeredAcc"),
    product: componentProps?.product
      ? sanitizeText(componentProps?.product)
      : t("kf.registeronlineproduct.label.product"),
    products: componentProps?.products
      ? sanitizeText(componentProps?.products)
      : t("kf.registeronlineproduct.label.products"),
    toAccount: componentProps?.toAccount
      ? sanitizeText(componentProps?.toAccount)
      : t("kf.registeronlineproduct.label.toAccount"),
    productSection: componentProps?.productSection
      ? sanitizeText(componentProps?.productSection)
      : t("kf.registeronlineproduct.label.productSection"),
    requiredFields: t("kf.registeronlineproduct.label.requiredFields"),
    firstName: t("kf.registeronlineproduct.label.firstName"),
    lastName: t("kf.registeronlineproduct.label.lastName"),
    address: t("kf.registeronlineproduct.label.address"),
    city: t("kf.registeronlineproduct.label.city"),
    state: t("kf.registeronlineproduct.label.state"),
    zipCode: t("kf.registeronlineproduct.label.zipCode"),
    installationDate: t("kf.registeronlineproduct.label.installationDate"),
    fnameError: t("kf.registeronlineproduct.label.fnameError"),
    lnameError: t("kf.registeronlineproduct.label.lnameError"),
    addressError: t("kf.registeronlineproduct.label.addressError"),
    cityError: t("kf.registeronlineproduct.label.cityError"),
    stateError: t("kf.registeronlineproduct.label.stateError"),
    zipcodeError: t("kf.registeronlineproduct.label.zipcodeError"),
    validZipcode: t("kf.registeronlineproduct.label.validZipcode"),
    installationDateError: t(
      "kf.registeronlineproduct.label.installationDateError"
    ),
    submitReg: t("kf.registeronlineproduct.label.submitReg"),
    correctReg: componentProps?.correctReg
      ? sanitizeText(componentProps?.correctReg)
      : t("kf.registeronlineproduct.label.correctReg"),
    agreeTerm: componentProps?.agreeTerm,
    save: t("kf.registeronlineproduct.label.save"),
    installationDateValidError: t(
      "kf.registeronlineproduct.label.installationDateValidError"
    ),
    termCondition1: t("kf.registerOfflineProduct.label.termsCondition1"),
    termCondition2: t("kf.registerOfflineProduct.label.termsCondition2"),
    terms: t("kf.registerOfflineProduct.label.terms"),
    policy: t("kf.registerOfflineProduct.label.policy"),
    ariaLabels: {
      selectAll: t("kf.registeronlineproduct.aria.label.selectAll"),
      next: t("kf.registerOfflineProduct.label.aria.next"),
    },
    noProducts:
      componentProps?.subcopyText ??
      t("kf.registeronlineproduct.label.noProducts"),
    maxDateError: t("kf.registerOfflineProduct.label.maxDateError"),
    confirmationMainCopy:
      componentProps?.confirmationMainCopy ??
      t("kf.registeronlineproduct.label.confirmationMainCopy"),
    confirmationSubCopy:
      componentProps?.confirmationSubCopy ??
      t("kf.registeronlineproduct.label.confirmationSubCopy"),
    phone: t("kf.checkout.label.phone"),
    validPhone: t("kf.contactus.error.validPhone"),
    noPhoneError: t("kf.contactus.error.noPhoneError"),
    phoneNumber: t("kf.contactus.label.phoneNumber"),
    genericError: componentProps?.genericError
      ? componentProps?.genericError
      : t("kf.error.message.genericError"),
    fetchDataError: t("kf.myProducts.label.fatchingDataError"),
    serverError: t("kf.registerOfflineProduct.error.serverError"),
    productInformationTitle: t(
      "kf.registerOfflineProduct.label.productInformationTitle"
    ),
    validUSPhone: t("kf.checkout.error.validUSPhone"),
  }

  return i18n
}

export default useRegisterOnlineProducti18n
